module.exports = __webpack_public_path__ + "static/IllichRealty-78bf649ebcd62221584ef20c72787c22.svg";